import angular from 'angular';
import fullBetName from './fullBetNameFilter';
import capitalize from './capitalizeFilter';
import autoSelectText from './autoSelectText';
import arrayService from './createArrayService';
import nabTrans from './transService';
import modalSvc from './modal/modalService';
import modalSvcConfig from './modal/modalServiceProvider';

// this is an old module that is deprecated
// and all parts should moved to 7Shop.Common
const moduleName = angular.module('ngLib', [])
  .filter('fullBetName', fullBetName)
  .filter('capitalize', capitalize)
  .directive('autoSelectText', autoSelectText)
  .service('arrayService', arrayService)
  .service('nabTrans', nabTrans)
  .factory('modalSvc', modalSvc)
  .provider('modalSvcConfig', modalSvcConfig)
  .name;

export default moduleName;
